import { render, staticRenderFns } from "./CriterionManagement.vue?vue&type=template&id=3c4a7337"
import script from "./CriterionManagement.vue?vue&type=script&lang=js"
export * from "./CriterionManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports